import * as R from "ramda";

const lengthValidation = (predicate: (l: number) => boolean, password: string) => predicate(password.length);

const shortLengthValidation = R.partial(lengthValidation, [(l: number) => l >= 8]);

const longLengthValidation = R.partial(lengthValidation, [(l: number) => l > 0 && l < 16]);

const hasCharacter = (charsToCheck: string, password: string) =>
  R.any(c => charsToCheck.includes(c as string))(password.split(""));

const hasNumber = R.partial(hasCharacter, ["0123456789"]);

const hasSpecialChar = R.partial(hasCharacter, ["@#$&*¡!¿?{}[],=.+-'/<>:;"]);

const equalStrings = (s1: string, s2: string) => s1 === s2;

const passwordsMatch = (s1: string, s2: string) => s1 !== "" && equalStrings(s1, s2);

const hasCapitalLetter = (password: string) => !equalStrings(password, password.toLowerCase());

export const passwordValidations = [
  shortLengthValidation,
  longLengthValidation,
  hasCapitalLetter,
  hasNumber,
  hasSpecialChar,
  passwordsMatch,
];
